/** Warm visible project capabilities once the signed-in app restores its data. */
import { useEffect } from 'react';
import { warmNavigation } from '../services/WorkspaceNavigationCache';
import { DataService } from '../services/DataService';
import { warmProjectPermissions } from '../features/projects/hooks/useProjectPermissions';

export function useInitialProjectAccess(userId: string | null | undefined, workspaceId?: string | null): void {
  useEffect(() => {
    if (!userId) return;
    let active = true;
    let previousIds = '';
    const warm = () => {
      if (!active) return;
      const ids: string[] = DataService.getProjects()
        .map((project: { id: string }) => project.id)
        .filter((id: string) => !DataService.isProjectAwaitingSave(id))
        .sort().slice(0, 500);
      const signature = ids.join(',');
      if (!signature || signature === previousIds) return;
      previousIds = signature;
      void warmProjectPermissions(ids, userId).catch(() => { previousIds = ''; });
      if (workspaceId) void warmNavigation(userId, workspaceId, ids).catch(() => { previousIds = ''; });
    };
    const unsubscribe = DataService.subscribe(warm);
    void DataService.waitForInitialization().then(warm);
    return () => { active = false; unsubscribe(); };
  }, [userId, workspaceId]);
}
